<template>
  <basic-container>
    <div class="search">
      <el-form ref="routeQueryForm" :model="query" :inline="true" size="mini">
        <el-form-item label="订单号">
          <el-input
            @keydown.enter.native.prevent="querySearch"
            placeholder="请输入订单号"
            v-model="query.orderNo"
            clearable
          />
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateArray"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            end-placeholder="结束日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="站点" prop="stationId">
          <yd-common-selector
            v-model="query.stationId"
            placeholder="请输入关键字查找线路名称"
            :options="stationNameList"
          />
        </el-form-item>
        <el-form-item label="司机车牌" prop="driverInfo">
          <el-input v-model="query.driverInfo" clearable placeholder="请输入内容" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="searchChange">
            筛选
          </el-button>
          <el-button type="danger" icon="el-icon-delete" :loading="loading" @click="searchReset">
            清空
          </el-button>
          <el-button type="primary" icon="el-icon-search" @click="openMap">查看在线司机</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <yd-table
        :data="driverData"
        :loading="loading"
        :pagination="pagination"
        @onChange="onTableChange"
      >
        <el-table-column label="司机" prop="driverName" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.driverName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="已接订单编号" prop="orderNo" align="center" width="300">
          <template slot-scope="scope">
            <el-tooltip placement="right" effect="dark" trigger="hover">
              <el-button type="text">{{ scope.row.orderNo }}</el-button>
              <template v-slot:content>
                <span style="cursor: pointer" @click="copyOrderNo(scope.row.orderNo)">复制</span>
              </template>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="车辆牌照" prop="carNum" align="center" width="100">
          <template slot-scope="scope">
            <el-tooltip placement="right" effect="dark" trigger="hover">
              <el-button type="text">{{ scope.row.carNum }}</el-button>
              <template v-slot:content>
                <span style="cursor: pointer" @click="copyOrderNo(scope.row.carNum)">复制</span>
              </template>
            </el-tooltip>
          </template>
          <!-- <template slot-scope="scope">
            {{ scope.row.carNum || '-' }}
          </template> -->
        </el-table-column>
        <el-table-column label="订单类型" prop="type" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.type ? scope.row.type : '接单' }}
          </template>
        </el-table-column>
        <el-table-column label="订单距离（公里）" prop="orderDistance" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.orderDistance || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="实际付给司机金额" prop="price" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.price / 100 || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="接单时间" prop="robTime" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.robTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="订单出发时间" prop="tripTime" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.tripTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="接单时经度" prop="robPoint" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.robPoint ? scope.row.robPoint.lon.toFixed(6) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="接单时纬度" prop="driverPhone" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.robPoint ? scope.row.robPoint.lat.toFixed(6) : '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="接单时离出发地距离（公里）"
          prop="robDistance"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            {{ parseInt(scope.row.robDistance / 1000) || '-' }}
          </template>
        </el-table-column>

        <el-table-column label="是否拼单" prop="mergeType" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.mergeType === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
      </yd-table>
    </div>

    <div v-if="visible">
      <el-dialog title="司机位置信息" :visible.sync="visible" width="1200px">
        <MapInfo :data="mapData" :centerPoint="centerPoint" />
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
  import { queryAllFstation } from '@/api/transport/routeset'
  import { postDriverCount, postDriverPage, getForderDriverInfo } from '@/api/dispatch/index'
  import MapInfo from './map'
  import { copyText } from '@/util'
  export default {
    components: {
      MapInfo
    },
    data() {
      return {
        visible: false,
        tableData: [],
        loading: false,
        query: {},
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        dateArray: [],
        driverData: [],
        mapData: [],
        centerPoint: [102.718437, 25.012356], // 默认云滴总部
        stationNameList: []
      }
    },
    watch: {},
    mounted() {
      this.getAllStation()
    },
    methods: {
      async copyOrderNo(v) {
        if (!v) {
          return
        }
        await copyText(v)
        this.$message.success('复制成功')
      },
      async openMap(v) {
        this.visible = true
        const { data, code } = await getForderDriverInfo()
        if (code === 0) {
          this.mapData = data
          const icon = {
            type: 'image',
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
            size: [25, 30],
            anchor: 'bottom-center'
          }
          this.mapData.forEach((item) => {
            item.position = item.location.split(',')
            item.zooms = [10, 20]
            item.zIndex = 100
            item.icon = icon
            item.text = {
              content: item.plateNumber,
              direction: 'right',
              offset: [0, -5],
              style: {
                fontSize: 14,
                fontWeight: 'normal',
                fillColor: '#fff',
                fold: true,
                padding: '2, 5',
                backgroundColor: '#07c160'
              }
            }
          })
        }
      },
      tabChange(tab, event) {
        this.searchReset()
      },
      initPage() {
        if (this.dateArray.length > 0) {
          this.query.beginTime = this.dateArray[0]
          this.query.endTime = this.dateArray[1]
        }
        const params = {
          ...this.pagination,
          ...this.query
        }
        this.getDriverList(params)
      },
      searchChange() {
        this.pagination.pageNo = 1
        this.initPage()
      },
      searchReset() {
        this.query = {}
        this.dateArray = []
        this.pagination.pageNo = 1
        this.initPage()
      },
      // 获取所有的站点
      getAllStation() {
        queryAllFstation().then((res) => {
          if (!Array.isArray(res.data)) {
            return
          }
          res.data.forEach((it) => {
            it.label = it.stationName
            it.value = it.id
          })
          this.stationNameList = res.data
        })
      },

      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.pagination.page = current
        this.pagination.pageSize = pageSize
        this.initPage()
      },

      getDriverList(params) {
        this.loading = true
        postDriverPage(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.driverData = data
              this.getDriverCount(params)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getDriverCount(params) {
        postDriverCount(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.pagination.total = data
            }
          })
          .finally(() => {})
      }
    }
  }
</script>

<style>
  .add-button {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .route-pagination {
    margin-left: 65%;
  }
</style>
